import React, { useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Zap } from "lucide-react";

const DEFAULT_TIERS = [
  { key: "feature", label: "Homepage feature", price: 2.0, hours: 5 },
  { key: "spotlight48", label: "48-hour spotlight", price: 5.0, hours: 48 },
];

const hoursText = (h) => (h >= 24 ? `${h / 24} day${h / 24 === 1 ? "" : "s"}` : `${h} hours`);

// Lets a seller choose a feature tier and sends them to Stripe checkout for that tier.
export const BumpTierPicker = ({
  listingId,
  tiers,
  onCancel,
  cancelLabel = "Not now",
  confirmPrefix = "Feature",
  testidPrefix = "bump",
}) => {
  const list = tiers && tiers.length ? tiers : DEFAULT_TIERS;
  const [tier, setTier] = useState(list[0].key);
  const [busy, setBusy] = useState(false);
  const selected = list.find((t) => t.key === tier) || list[0];

  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listingId}/bump/checkout`, {
        origin_url: window.location.origin,
        tier,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="space-y-2" data-testid={`${testidPrefix}-tiers`}>
        {list.map((t) => {
          const active = tier === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTier(t.key)}
              data-active={active}
              data-testid={`${testidPrefix}-tier-${t.key}`}
              className="w-full hairline p-3 flex items-center justify-between text-left transition-colors"
              style={active ? { borderColor: "#1E3A2B", background: "#F0EBE1" } : {}}
            >
              <span className="flex items-center gap-2">
                {t.key === "spotlight48" ? (
                  <Zap size={15} style={{ color: "#2563EB" }} />
                ) : (
                  <Sparkles size={15} style={{ color: "#1E3A2B" }} />
                )}
                <span className="text-sm leading-tight">
                  <span className="font-medium block">{t.label}</span>
                  <span className="text-neutral-500 text-xs">Homepage grid · {hoursText(t.hours)}</span>
                </span>
              </span>
              <span className="font-display text-lg">${Number(t.price).toFixed(2)}</span>
            </button>
          );
        })}
      </div>
      <div className="mt-4 flex gap-3">
        {onCancel && (
          <button type="button" className="btn-outline flex-1" onClick={onCancel} data-testid={`${testidPrefix}-cancel`}>
            {cancelLabel}
          </button>
        )}
        <button type="button" className="btn-primary flex-1" onClick={go} disabled={busy} data-testid={`${testidPrefix}-confirm`}>
          {busy ? "Redirecting…" : `${confirmPrefix} for $${Number(selected.price).toFixed(2)}`}
        </button>
      </div>
    </div>
  );
};

export default BumpTierPicker;
